import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function PasswordResetUnavailable() {
  const { t } = useTranslation();

  return (
    <div>
      <h2 className="mb-2 text-2xl font-bold text-gray-900">
        {t("passwordReset.forgotTitle")}
      </h2>
      <p className="mb-6 text-gray-600" role="status">
        {t("passwordReset.unavailable")}
      </p>
      <Link to="/login" className="text-sm font-medium text-primary-600 hover:text-primary-700">
        {t("passwordReset.backToLogin")}
      </Link>
    </div>
  );
}
